'use client'
import { ResourceCardWithImage, ResourceCardWithIcon } from '@/components/common/ResourceCard/ResourceCard'

import type { ResourceCardSectionFields } from '@/types/contentful/resourceSectionType'

export const ResourceCardSection = ({ sections: cards, cardsLayout = 'With Image' }: ResourceCardSectionFields) => {
  if (!cards?.length || !cardsLayout) return null

  const groupedByFirstLetter = () => {
    return cards.reduce(
      (acc, item) => {
        const title = item.fields?.title || ''
        const firstLetter = title.charAt(0).toUpperCase()
        if (!acc[firstLetter]) acc[firstLetter] = []
        acc[firstLetter].push(item)

        return acc
      },
      {} as Record<string, typeof cards>,
    )
  }

  const clickHandler = (id: string) => {
    const targetElement = document.getElementById(id)
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }

  return (
    <section data-name="resource-card-section" className="bg-grey-100">
      {cardsLayout != 'With Image' && (
        <div className="bg-grey-200 p-4">
          <div className="scrollbar-thin scrollbar-thumb-gray-300 flex w-full space-x-6 overflow-x-auto whitespace-nowrap md:space-x-9 desktop:mx-auto desktop:max-w-content ">
            {Object.keys(groupedByFirstLetter()).map((letter) => (
              <button key={letter} className={'text-base font-semibold uppercase text-grey-900'} onClick={() => clickHandler(letter)}>
                {letter}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="px-4 py-8 lg:px-[120px] lg:py-24">
        {cardsLayout == 'With Image' ? (
          <div className="grid w-full grid-cols-1 gap-4 bg-grey-100 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12 xl:grid-cols-4 desktop:mx-auto desktop:max-w-content">
            {cards.map(({ fields: { title, image, downloadLink } }, index) => (
              <div key={`${title},${index}`} className="flex size-full flex-1 items-center justify-center">
                <ResourceCardWithImage title={title} image={image} downloadLink={downloadLink} />
              </div>
            ))}
          </div>
        ) : (
          <div className="desktop:mx-auto desktop:max-w-content ">
            {Object.entries(groupedByFirstLetter())?.map(([letter, items]) => {
              return (
                <div key={letter} id={letter?.toUpperCase()}>
                  <p className="mb-6 rounded-2xl bg-[linear-gradient(92.41deg,_#03A54E_0%,_#00873F_97.91%)] px-5 py-4 font-semibold text-white">{letter}</p>
                  <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
                    {items?.map(({ fields: { title, downloadLink } }, index) => {
                      return (
                        <div key={`${title}-${index}`} className="flex size-full flex-1">
                          <ResourceCardWithIcon title={title} downloadLink={downloadLink} />
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
